var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"label font-weight-bold label-lg label-inline label-light-success",staticStyle:{"width":"max-content"}},[_vm._v(_vm._s(_vm.getMerchantName()))])
}
var staticRenderFns = []

export { render, staticRenderFns }